import React from 'react';

function CellWithSubtext({ title = '', subtitle = '' }) {
    return (
        <div className="table-cell_with-subtext">
            <b>{title}</b>
            <span>{subtitle}</span>
        </div>
    );
}


export default CellWithSubtext;
